import axios from 'axios';
import store from '../store/index';

class AuthService {
    constructor() {
        if (AuthService.instance) {
            return AuthService.instance;
        }

        this._isAuthorized = !!localStorage.getItem('access_token');

        AuthService.instance = this;
    }

    get isAuthorized() {
        return this._isAuthorized;
    }

    async login(token) {
        if(token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            localStorage.setItem('access_token', token);
            this._isAuthorized = token;
            await store.dispatch('global/getUser');
        }
    }

    async logout() {
        this.clearStorage();
        this._isAuthorized = '';
        delete axios.defaults.headers['Authorization'];
        store.commit('global/setUser', {});
    }

    clearStorage() {
        let cookieAccept = localStorage.getItem(`cookie-accept`);

        localStorage.clear();
        sessionStorage.clear();

        if (cookieAccept) {
            localStorage.setItem(`cookie-accept`, cookieAccept);
        }
    }
}

export default new AuthService();
